<template>
  <v-app id="cidadaos-duplicados" class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="CPF/CNS ou nome do paciente"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :search="search"
          item-key="index"
          class="elevation-1"
          show-expand
          :expanded.sync="expanded"
        >
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:item.dt_nascimento="{ item }">
            {{ formatDate(item.dt_nascimento) }}
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="9">
              <table class="table table-interna table-interna-acompanhamento">
                <thead>
                  <tr>
                    <th>CEP</th>
                    <th>ENDEREÇO</th>
                    <th>BAIRRO</th>
                    <!--    <th v-if="exibirCopilot">Suporte</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ item.endereco.ds_cep }}</td>
                    <td>
                      {{ item.endereco.no_tipo_logradouro }}
                      {{ item.endereco.ds_logradouro }},
                      {{ item.endereco.nu_numero }}
                      {{ item.endereco.ds_complemento }}
                    </td>
                    <td>{{ item.endereco.no_bairro }}</td>
                    <!-- <td v-if="exibirCopilot">
                      <copilot :item="item" :rules="item.rules"></copilot>
                    </td> -->
                  </tr>
                </tbody>
              </table>
              <table class="table table-interna">
                <thead>
                  <tr>
                    <th>Data procedimento</th>
                    <th>Código procedimento</th>
                    <th>Quantidade</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ formatDate(item.dt_procedimento) }}</td>
                    <td>{{ item.procedimento }}</td>
                    <td>1</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      enabled: null,
      search: '',
      expanded: [],
      headers: [
        {
          text: 'FOLHA',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'folha',
        },
        {
          text: 'SEQUÊNCIA',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'sequencia',
        },
        {
          text: 'CPF PACIENTE',
          align: 'start',
          filterable: true,
          sortable: false,
          value: 'nu_cpf_cidadao',
        },
        {
          text: 'CNS PACIENTE',
          align: 'start',
          filterable: true,
          sortable: false,
          value: 'nu_cns',
        },
        {
          text: 'NOME PACIENTE',
          align: 'start',
          filterable: true,
          sortable: false,
          value: 'no_cidadao',
        },
        {
          text: 'SEXO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'sexo',
        },
        {
          text: 'NASCIMENTO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'dt_nascimento',
        },
        /*         {
          text: 'RAÇA/COR',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'racacor',
        }, */
        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => {
        let seq_global = Number(item.seq_global) || 0
        let sequencia = ((seq_global - 1) % 999) + 1
        let folha = Math.floor((seq_global - 1) / 999) + 1
        return {
          ...item,
          index: index,
          sequencia: sequencia,
          folha: folha,
        }
      })
    },
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },
  },
}
</script>

<style lang="scss"></style>
